import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import "../Dynamic/ContainerTimeLineOverlay.scss";
import { InventoryApiService } from '../../Service/InventoryApiService';
import { CommonService } from '../../Service/CommonService';

interface ContainerTimeLineOverlayProps {
    id?: string | number;
    onClose: () => void;
}

const ContainerTimeLineOverlay: React.FC<ContainerTimeLineOverlayProps> = ({ id, onClose }) => {

    const [viewOffCanvas, setViewOffCanvas] = useState(true);
    const [timelineDetails, setTimelineDetails] = useState<any>(null);
    const [locationDetails, setLocationDetails] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [containerTimeLineOverlayData, setContainerTimeLineOverlayData] = useState<any>({});
    const [recentLiquidFillDetailsData, setRecentLiquidFillDetailsData] = useState<any>({});

    const handleCloseOffCanvas = () => {
        setViewOffCanvas(false);
        onClose();
    };

    useEffect(() => {
        fetchData();
        fetchRecentLiquidFillDetailsById();
    }, []);

    const fetchData = async () => {
        try {
            const response = await InventoryApiService.getContainerTimeLineOverlayBarrelDetailsById(id);
            setContainerTimeLineOverlayData(response.data);
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };

    const fetchRecentLiquidFillDetailsById = async () => {
        try {
            const response = await InventoryApiService.getRecentLiquidFillDetailsById(id);
            setRecentLiquidFillDetailsData(response.data);
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };

    return (
        <>
            {/* <button onClick={handleCloseOffCanvas}>Show Sidebar</button> */}

            {viewOffCanvas && (
                <div className="container-offcanvas-wrapper ">
                    <div className="container-panel-left" onClick={handleCloseOffCanvas}></div>

                    <div className="container-panel-inner">
                        <div className="header">
                            <div className="header-inner d-flex justify-content-between align-items-start">
                                <h3 className="main-heading mb-0">
                                    Container Liquid Timeline
                                </h3>

                                <button onClick={handleCloseOffCanvas} className="close-btn">
                                    <CloseIcon />
                                </button>
                            </div>
                        </div>

                        <div className="container-panel-body">
                            <div className="content-heading">
                                Initial Fill Details
                            </div>
                            <div className="info-grid">
                                <div className="info-item">
                                    <span className="label">Container Id</span>
                                    {/* <hr /> */}
                                    <span className="value">{containerTimeLineOverlayData.barrelNumber ?? "-"}</span>
                                </div>

                                <div className="info-item">
                                    <span className="label">Lot No</span>
                                    {/* <hr /> */}
                                    <span className="value">{containerTimeLineOverlayData.lotNo ?? "-"}</span>
                                </div>

                                <div className="info-item">
                                    <span className="label">DSP</span>
                                    {/* <hr /> */}
                                    <span className="value">{containerTimeLineOverlayData.dsp ?? "-"}</span>
                                </div>

                                <div className="info-item">
                                    <span className="label">Producer</span>
                                    {/* <hr /> */}
                                    <span className="value">{containerTimeLineOverlayData.producer ?? "-"}</span>
                                </div>

                                <div className="info-item">
                                    <span className="label">Mash Bill</span>
                                    {/* <hr /> */}
                                    <span className="value">{containerTimeLineOverlayData.mashBill ?? "-"}</span>
                                </div>
                               <div className="info-item description-item">
                                    <span className="label">Description</span>
                                    <span className="value">
                                        {containerTimeLineOverlayData?.description ? (
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: containerTimeLineOverlayData.description
                                                }}
                                            />
                                        ) : (
                                            "-"
                                        )}
                                    </span>
                                </div>
                            </div>
                            <div className="content-heading">
                                Recent Liquid Fill Details
                            </div>
                            <div className="table-wrapper table-responsive">
                                <table className="service-detail-table mb-0 table">
                                    <thead>
                                        <tr>
                                            <th>Timestamp</th>
                                            <th>Request Name</th>
                                            <th>Container Id</th>
                                            <th>Lot #</th>
                                            <th>DSP</th>
                                            <th>Producer</th>
                                            <th>Mash Bill</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recentLiquidFillDetailsData && recentLiquidFillDetailsData.length > 0 ? (
                                            recentLiquidFillDetailsData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{CommonService.formatDateTime(item.createdDate)}</td>
                                                <td>{item.requestName}</td>
                                                <td>{item.barrelNumber}</td>
                                                <td>{item.lotNo}</td>
                                                <td>{item.dsp}</td>
                                                <td>{item.producer}</td>
                                                <td>{item.mashBill}</td>
                                                <td>
                                                <p>{containerTimeLineOverlayData?.description ? (
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.description
                                                        }}
                                                        />
                                                    ) : (
                                                        "-"
                                                    )}
                                                </p>
                                                </td>
                                            </tr>
                                            ))
                                        ) : (
                                            <tr>
                                            <td colSpan={8} style={{ textAlign: "center" }}>No data found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ContainerTimeLineOverlay;